export default "__VITE_ASSET__C6C37Bl2__"